<template>
    <div style="padding-left: 35px; padding-right: 35px;">
        <v-row style="background-color: #fff; padding: 30px;">
            <v-col cols="2">
                <v-icon large icon="mdi-arrow-left" @click="$router.push('/config')"
                    style="font-size: 46px">mdi-arrow-left</v-icon>
            </v-col>
            <v-col cols="8" style="text-align: center!important; margin-bottom: 20px;">
                <span style="text-transform: uppercase; letter-spacing: 5px;">
                    MAPPING
                </span>
            </v-col>
            <v-divider></v-divider>
            <div style="min-height: 800px; width: 100%;">
                <div style="width: 100%; text-align: center;" v-if="isLoadingFbsTree">

                    <v-progress-circular color="primary" indeterminate></v-progress-circular>
                    <h6>Loading data...</h6>

                </div>
                <div v-else>
                    <v-btn @click="mapFbs()"
                                            :disabled="selectedProcessCells == '' && selectedUnits == ''"
                                            prepend-icon="mdi-content-copy">Clone to structure</v-btn>
                    <div v-for="item in fbsTree" :key="item" class="mt-5">
                        <v-pagination
                            v-model="page"
                            :length="pageCount(item.areas)"
                            :total-visible="10"
                            @input="onPageChange"
                        ></v-pagination>
                        <v-card v-for="area in paginatedAreas(item.areas)" :key="area" style="margin-bottom: 25px;" elevation="4">
                            <v-toolbar color="transparent">
                                <v-list-item>
                                    <div class="v-list-item-title" style="font-weight: bold;">{{ area.name }}</div>
                                    <div class="v-list-item-subtitle" style="font-weight: bold;">{{ area.fbs_id }}</div>
                                </v-list-item>
                                <template v-slot:append>
                                    <v-btn variant="text" color="blue" style="margin-right: 10px "
                                        prepend-icon="mdi-repeat" @click="selectedArea = area">Change building
                                        <v-dialog activator="parent" max-width="340">
                                            <template v-slot:default="{ isActive }">
                                                <v-card title="Change building">
                                                    <v-card-text>
                                                        <v-select label="Select"
                                                            :items="this.buildings"
                                                            v-model="selectedBuilding"
                                                            :item-title="item => item.name"
                                                            :item-value="item => item"
                                                            variant="outlined">
                                                        </v-select>
                                                    </v-card-text>
                                                    <template v-slot:actions>
                                                        <v-btn color="primary" @click="setBuilding(isActive)">
                                                            <v-icon left>mdi-check</v-icon>
                                                            <span>Save</span>
                                                        </v-btn>
                                                        <v-btn class="ml-auto" text="Close"
                                                            @click="isActive.value = false;selectedArea=null">
                                                        </v-btn>
                                                    </template>
                                                </v-card>
                                            </template>
                                        </v-dialog>
                                    </v-btn>
                                </template>
                            </v-toolbar>
                            <v-divider></v-divider>

                            <div v-for="pcell in area.process_cells" :key="pcell" style="padding: 10px;">
                                <v-toolbar color="transparent">
                                    <v-list-item :title="pcell.name" :subtitle="pcell.fbs_id"></v-list-item>
                                    <v-btn v-if="!pcell.marked_for_export" color="primary" @click="selectedProcessCells.push(pcell.id);pcell.marked_for_export=true">SELECT for export</v-btn>
                                    <v-btn v-else color="primary" @click="selectedProcessCells.splice(selectedProcessCells.indexOf(pcell.id));pcell.marked_for_export=false">REMOVE from export</v-btn>
                                </v-toolbar>
                                <div v-if="pcell.units&&pcell.units.length>0">
                                    <v-data-table  v-model="selectedUnits" :items="pcell.units" item-value="id" items-per-page="25" show-select>
                                    </v-data-table>
                                </div>
                            </div>
                        </v-card>
                    </div>
                </div>
                <div class="text-center">
                    <v-snackbar v-model="snackbar" :timeout="timeout" color="success">
                        {{ text }}
                    </v-snackbar>
                </div>
            </div>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios'
import { ref } from 'vue';

export default {
    data() {
        return {
            open: [],
            fbsTree: [],
            checkedItem: null,
            selectedItems: [],
            selected: [],
            snackbar: false,
            text: "",
            timeout: 3000,
            isLoadingFbsTree: false,
            buildings: [],
            selectedBuilding: null,
            selectedArea: null,
            itemsPerPage: 3,
            selectedUnits: [],
            selectedProcessCells: ref([]),
            page: 1,
            search: '',
        };
    },
    computed: {
        paginatedAreas() {
            return (areas) => {
                const start = (this.page - 1) * this.itemsPerPage;
                const end = start + this.itemsPerPage;
                return areas.slice(start, end);
            };
        },
        pageCount() {
            return (areas) => {
                return Math.ceil(areas.length / this.itemsPerPage);
            };
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        async loadData() {
            this.isLoadingFbsTree = true;
            try {
                const [buildingsRes, fbsTreeRes] = await Promise.all([
                    axios.get("/apiv1/buildings/list"),
                    axios.get("/apiv1/fbstree")
                ]);
                this.buildings = buildingsRes.data;
                this.fbsTree = fbsTreeRes.data.map(item => {
                    item.areas = item.areas.map(area => {
                        area.process_cells = area.process_cells.map(pcell => {
                            return {...pcell, marked_for_export: false};
                        });
                        return area;
                    });
                    return item;
                });
                
            } catch (err) {
                console.error(err);
            } finally {
                this.isLoadingFbsTree = false;
            }
        },
        mapFbs() {
            axios.post('/apiv1/fbs/mapfbs', { units: this.selectedUnits, process_cells: this.selectedProcessCells }).then(res => {
                console.log(res);
                this.snackbar = true;
                this.text = "Data has been copied correctly to the structure."
                this.selectedItems = [];
                this.selectedUnits = [];
                this.selectedProcessCells = [];

            }).catch(err => {
                console.log(err);

            })
        },
        async setBuilding(activator) {
            console.log(this.selectedBuilding);
            axios.post('/apiv1/fbscfg/set-building', { building: this.selectedBuilding.id ,area:this.selectedArea.id}).then(res => {
                console.log(res);
                this.selectedArea.building = this.selectedBuilding;
                this.selectedArea = null;
                this.selectedBuilding = null;
                activator.value = false;
            }).catch(err => {
                console.log(err);
            })
        },
        onPageChange(newPage) {
            this.page = newPage;
        }
    },
    components: {
    }
};
</script>
<style scoped></style>
